export default __webpack_public_path__ + "static/solutions-triangle-retailers.url-4ff3e6a64832602bcea0af65e0a4a808.svg";